import { render, staticRenderFns } from "./detail-chart.vue?vue&type=template&id=27c2bbb8&scoped=true&"
import script from "./detail-chart.vue?vue&type=script&lang=js&"
export * from "./detail-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2bbb8",
  null
  
)

export default component.exports